import styled from 'styled-components'
import { device } from '../../styles/GlobalVariables'

export const FooterStripWrap = styled.div`
  ${device.small} {
    display: none;
  }

  > div {
    background: transparent;
  }
`
